import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

import PageTitle from "../../layouts/PageTitle";
import FormField from "../../components/ui/FormField";
import SubmitButton from "../../components/ui/SubmitButton";
import { changeAdminPassFunc } from "../../../store/custom-actions/admins-actions/ChangeAdminPassSlicer";

export default function ChangeAdminPassword() {
  const { t } = useTranslation();
  const { adminId } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const { loading: changePassLoading } = useSelector(
    (state) => state.changeAdminPassSlicer
  );

  const onSubmit = async (data) => {
    if (data.password !== data.password_confirmation) {
      toast.error(t("Please Confirm New Password"), {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      return;
    }

    const payload = {
      new_password: data.password,
      new_password_confirmation: data.password_confirmation,
    };

    const result = await dispatch(
      changeAdminPassFunc({ adminId, data: payload })
    );

    if (changeAdminPassFunc.fulfilled.match(result)) {
      navigate("/admins");
    }
  };

  return (
    <>
      <PageTitle
        motherMenu={"Admins"}
        activeMenu={"Update Admin Password"}
        motherMenuPath="/admins"
      />
      <div className="row">
        <div className="col-xl-12 col-xxl-12">
          <div className="card">
            <div className="card-header">
              <h5 className="card-title">
                {t("Update")} {t("Admin Password")}
              </h5>
            </div>
            <div className="card-body">
              <form
                id="change-admin-pass-form"
                onSubmit={handleSubmit(onSubmit)}
              >
                <div className="row">
                  <div className="col-sm-12 col-md-6">
                    <FormField
                      label={t("New Password")}
                      name="password"
                      type="password"
                      register={register}
                      required={true}
                      errors={errors}
                    />
                  </div>
                  <div className="col-sm-12 col-md-6">
                    <FormField
                      label={t("Confirm New Password")}
                      name="password_confirmation"
                      type="password"
                      register={register}
                      required={true}
                      errors={errors}
                    />
                  </div>
                </div>
                <div className="text-end">
                  <SubmitButton
                    form="change-admin-pass-form"
                    isLoading={changePassLoading}
                    label="Submit"
                    loadingLabel={t("Loading")}
                  />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
